import Link from 'next/link';
import { useRouter } from 'next/router';
import { useUrlQueryParameters } from '@/website/hooks/useUrlQueryParameters';
import { useLocalTranslation } from '@jove-frontend/uikit';
import clsx from 'clsx';

export const CompanyToggleButtons = () => {
  const router = useRouter();
  const { getBusinessInsuranceCompleteLink } = useUrlQueryParameters();
  const { $t } = useLocalTranslation();

  return (
    <div className="inline-block rounded-full border border-gray-300 bg-white p-1 py-2 text-sm font-semibold">
      <Link
        href={getBusinessInsuranceCompleteLink()}
        className={clsx('rounded-full px-4 py-2', {
          'bg-gray-dark text-white': router.asPath.startsWith('/personal'),
        })}
      >
        {$t('page:CompanyToggleButtons.for_you')}
      </Link>
      <Link
        href="/"
        className={clsx('rounded-full px-4 py-2 ', {
          'bg-gray-dark text-white': router.asPath.match(/\/$/) || !router.asPath.startsWith('/personal'),
        })}
      >
        {$t('page:CompanyToggleButtons.for_partners')}{' '}
        <span
          className={clsx({
            'text-brand-secondary': !router.asPath.match(/\/$/),
            'text-brand-primary': router.asPath.match(/\/$/),
          })}
        >
          {$t('page:CompanyToggleButtons.b2b')}
        </span>
      </Link>
    </div>
  );
};
